<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
      <h1>Jornalzinho - {{ tituloPromocao }}</h1>
      <b-row class="p-b-20">
        <b-col md="6" xl="6" sm="12">
          <b-button class="btn btn-danger m-w" @click="goBack">Cancelar</b-button>
        </b-col>
        <b-col md="6" xl="6" sm="12">
          <b-button class="btn btn-success m-w" @click="save" :disabled="!saveBtn">Salvar</b-button>
        </b-col>
      </b-row>
      <b-row v-if="readyToShow">
        <b-col cols="12">
          <b-card header="Inserir imagem">
            <b-row>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput0"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '1<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[0]"
                  @change="onChange"
                ></picture-input>
              </b-col>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput1"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '2<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[1]"
                ></picture-input>
              </b-col>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput2"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '3<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[2]"
                ></picture-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="4">
                <picture-input
                  :zIndex ="10"
                  ref="pictureInput3"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '4<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[3]"
                ></picture-input>
              </b-col>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput4"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '5<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[4]"
                ></picture-input>
              </b-col>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput5"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '6<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[5]"
                ></picture-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="4">
                <picture-input
                  ref="pictureInput6"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '7<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[6]"
                ></picture-input>
              </b-col>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput7"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '8<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[7]"
                ></picture-input>
              </b-col>
              <b-col cols="4">
                <picture-input
                  ref="pictureInput8"
                  :zIndex ="10"
                  :crop="false"
                  :removable="true"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    drag: '9<br>Arraste uma imagem <br> (ou clique aqui)',
                    change: 'Mudar foto',
                    remove: 'Remover foto'
                  }"
                  :prefill="prefillImages[8]"
                ></picture-input>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "editarimagem",
  components: { PictureInput, Loading },
  data: function() {
    return {
      isLoading: false,
      imageSource: null,
      tituloPromocao: null,
      saveBtn: false,
      selecionado: 2,
      readyToShow: false,
      prefillImages: []
    };
  },
  methods: {
    onChange(image) {
      if (image) {
        this.saveBtn = true;
      } else {
        this.saveBtn = false;
      }
    },
    goBack() {
      localStorage.removeItem("titulo_promocao");
      localStorage.removeItem("url_imagem");
      localStorage.removeItem("image");
      localStorage.removeItem("id_promocao");
      this.$router.go(-1);
    },
    trataImagens() {
      var array = [];
      for (let i = 0; i < 9; i++) {
        switch (i) {
          case 0:
            if (this.$refs.pictureInput0.image != null)
              array.push(this.$refs.pictureInput0.image);
            break;
          case 1:
            if (this.$refs.pictureInput1.image != null)
              array.push(this.$refs.pictureInput1.image);
            break;
          case 2:
            if (this.$refs.pictureInput2.image != null)
              array.push(this.$refs.pictureInput2.image);
            break;
          case 3:
            if (this.$refs.pictureInput3.image != null)
              array.push(this.$refs.pictureInput3.image);
            break;
          case 4:
            if (this.$refs.pictureInput4.image != null)
              array.push(this.$refs.pictureInput4.image);
            break;
          case 5:
            if (this.$refs.pictureInput5.image != null)
              array.push(this.$refs.pictureInput5.image);
            break;
          case 6:
            if (this.$refs.pictureInput6.image != null)
              array.push(this.$refs.pictureInput6.image);
            break;
          case 7:
            if (this.$refs.pictureInput7.image != null)
              array.push(this.$refs.pictureInput7.image);
            break;
          case 8:
            if (this.$refs.pictureInput8.image != null)
              array.push(this.$refs.pictureInput8.image);
            break;
        }
      }
      return array;
    },
    save() {
      axios
        .post(
          `${config.default.servidor}/gerencial/jornalzinho/imagem`,
          {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            promocaoid: localStorage.getItem("id_promocao").toString(),
            imagem: this.trataImagens()
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          } else {
            let toast = this.$toasted.show("Algo deu errado.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome"
            });
          }
          this.goBack();
        })
        .catch(error => {
          let toast = this.$toasted.show("Algo deu errado.", {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 5000,
            icon: "times",
            iconPack: "fontawesome"
          });
        });
    },
    async buscarImagens() {
      this.isLoading = true;
      await axios
        .get(
          `${
            config.default.servidor
          }/mobile/retorna-url-jornalzinho/${localStorage
            .getItem("enterprise_id")
            .toString()}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.data.data) {
            this.prefillImages = [];
            for (let i = 0; i < 9; i++) {
              const e = response.data.data[i] ? response.data.data[i] : null;
              this.prefillImages.push(e!= null ? e.split("?")[0] : null);
            }
            console.info(this.prefillImages)
          }
          if (response.data.data) this.saveBtn = true;
          this.readyToShow = true;
          this.isLoading = false;
        });
    }
  },
  beforeMount() {
    this.buscarImagens();
    this.tituloPromocao = localStorage.getItem("titulo_promocao").toString();
  }
};
</script>